<template>
  <div class="vheight evaluateDetail">
    <div class="container-boot">
      <div class="header-box">
        <div class="box-left">
          <div class="img-box">
            <svg-icon icon-class="building" class="iconstyle"></svg-icon>
          </div>
          <div class="title-box">
            <div class="title-h">{{ eaAreaName || detailObj.OrgName }}</div>
            <div class="title-t">深圳市{{ detailObj.CanTonName }}</div>
          </div>
        </div>
        <div class="box-right">
          <div>
            <el-date-picker
              v-model="searchDate"
              type="month"
              size="small"
              format="yyyy 年 MM 月"
              @change="searchChange"
              placeholder="选择月"
            >
            </el-date-picker>
          </div>
          <div class="fraction">
            排名
            <span>{{ detailObj.Rank || detailObj.CityRank || '-' }}</span>
            得分
            <span v-if="detailObj.Average">{{
              detailObj.Average ? detailObj.Average : '-'
            }}</span>
            <span v-else-if="detailObj.EvaCard > 0">{{
              detailObj.TotalScore
            }}</span>
            <span v-else>-</span>
          </div>
        </div>
      </div>
      <div class="tip" v-if="totalCount >= 0">
        共有<span>{{ totalCount }}</span
        >名业主评价
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :header-cell-style="getRowClass"
          @cell-click="cellClick"
          v-loading="loading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <div class="noData" v-else>暂无数据</div>
          </template>
          <!-- <el-table-column
            prop="EaHouseName"
            label="业主姓名"
          ></el-table-column> -->
          <el-table-column prop="EvaluateTime" label="评价时间">
            <template slot-scope="scope">
              <span>{{ scope.row.EvaluateTime | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="TotalScore" label="评价总分"></el-table-column>
          <el-table-column prop="Content" label="评价内容"></el-table-column>
          <el-table-column
            prop="PropertyReply"
            label="回复内容"
          ></el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div class="page">
          <of-page :page="page" @getData="getData()"></of-page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Page } from '@/models/page';
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController.js';
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      searchDate: '',
      tableData: [],
      propTable: [],
      detailObj: {},
      totalCount: 0,
      orgCode: '',
      evaluateObjType: 3,
      canReply: false,
      page: new Page(),
      eaAreaName: '',
    };
  },
  computed: { ...mapState(['token', 'userInfo']) },
  filters: {
    getScore(score, num) {
      if (score && num) {
        return (score / num).toFixed(1);
      } else if (score == 0 && num > 0) {
        return 0;
      } else {
        return '-';
      }
    },
    getDate(val) {
      if (val) {
        return val.replace('T', ' ');
      } else {
        return '-';
      }
    },
  },
  created() {
    this.eaAreaName = decodeURIComponent(this.$route.query.eaAreaName);
    this.CreditInformationController = new CreditInformationController();
    this.orgCode = this.$route.query.orgCode || '';
    this.evaluateObjType = this.$route.query.evaluateObjType;
    this.searchDate = new Date();
    this.getData();
    this.getDetail();
  },
  methods: {
    cellClick(row) {
      // keyId=' + key + '&type=' + this.evaluateObjType + '&disabled=1'
      this.$router.push({
        name: 'overallEvaluation',
        query: { keyId: row.KeyId, evaluateObjType: this.evaluateObjType },
      });
    },
    getRowClass({ rowIndex }) {
      if (rowIndex == 0) {
        return 'background-color:#eee;border-color:#ccc;';
      } else {
        return ' ';
      }
    },
    getData() {
      const searchYear = new Date(this.searchDate).getFullYear();
      const searchMonth = new Date(this.searchDate).getMonth() + 1;
      this.loading = true;
      this.CreditInformationController.GetEvaluateRecordList(
        '',
        '',
        this.orgCode,
        searchYear,
        searchMonth,
        this.evaluateObjType,
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum
      )
        .then((res) => {
          this.loading = false;
          if (res && res._Items) {
            this.tableData = res._Items;
            this.totalCount = res.TotalCount;
            this.page.getCurrtNum = res.TotalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: err,
          });
        });
    },

    searchChange() {
      this.page.currentPage = 1;
      this.tableData = [];
      this.getData();
      this.getDetail();
    },

    linkTo(code) {
      window.location.href =
        './evaluateDetail.html?orgCode=' + code + '&evaluateObjType=3';
    },

    linkOverallEvaluation(key) {
      window.location.href =
        '../../overallEvaluation/overallEvaluation.html?keyId=' +
        key +
        '&type=' +
        this.evaluateObjType +
        '&disabled=1';
    },
    getDetail() {
      const searchYear = new Date(this.searchDate).getFullYear();
      const searchMonth = new Date(this.searchDate).getMonth() + 1;
      // if (this.evaluateObjType != '1') {
      this.CreditInformationController.GetEaAreaEvaluateRecordList(
        //此处通过 角色 来判断不同的查询方式
        '',
        this.orgCode,
        searchYear,
        searchMonth,
        false,
        this.evaluateObjType == '3' ? '1' : this.evaluateObjType,
        0,
        -1
      )
        .then((res) => {
          this.detailObj = res.scoreResult;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err,
          });
        });
      // }
    },
  },
};
</script>
<style lang="scss">
.evaluateDetail {
  .header-box {
    .box-right {
      .el-input {
        width: 140px !important;
      }
      input {
        border: none;
      }
      .el-input__icon {
        color: #8c4f7f;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.evaluateDetail {
  width: 100%;
  box-sizing: border-box;
  .header-box {
    margin-top: 10px;
    display: flex;
    box-sizing: border-box;
    padding: 5px 10px;
    border: 1px solid #eee;
    border-radius: 5px;
    .box-left {
      width: 50%;
      display: flex;
      .img-box {
        width: 60px;
        height: 60px;
        font-size: 30px;
        color: #8c4f7f;
        border-radius: 30px;
        background: #eee;
        line-height: 60px;
        text-align: center;
      }
      .title-box {
        box-sizing: border-box;
        padding-left: 15px;
        flex: 1;
        .title-h {
          font-weight: bold;
          font-size: 18px;
          line-height: 35px;
        }
        .title-t {
          font-size: 12px;
        }
      }
    }
    .box-right {
      flex: 1;
      text-align: right;
      .fraction {
        line-height: 18px;
        padding-right: 25px;
        span {
          color: #8c4f7f;
          padding: 0 5px;
        }
      }
    }
  }
  .tip {
    line-height: 35px;
    span {
      color: #8c4f7f;
      padding: 0 5px;
    }
  }
  .footer {
    margin-top: 10px;
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;
    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;
      .delete {
        margin-left: 20px;
      }
    }
  }
}
</style>
